import React from 'react';
import { BrandsAPI } from '../../../../../../constructs/brands/interface';
import { useAPIContext } from '../../../../context/api';
import { AnyCreativityConfig, CreativityType } from '../../../../types/banner';
import { getHandlerForTemplate } from '../../../../handlers';

export const useCreateCreativityBanner = () => {
  const { callEndpoint } = useAPIContext();

  const createCreativityBanner = React.useCallback(
    async (
      bannerId: string,
      creativityType: CreativityType,
      config: AnyCreativityConfig,
      title: string,
      templateFamily?: string
    ) => {
      const clientHandler = getHandlerForTemplate(creativityType);

      const fileNamingPrefix = clientHandler.getFileNaming?.({ ...config, _creativityType: creativityType });

      try {
        const res = await callEndpoint<BrandsAPI, 'create-creativity-banner'>('brands', '/creativities', 'POST', {
          bannerId,
          creativityType,
          config,
          title,
          templateFamily,
          fileNamingPrefix
        });

        if (!res) throw new Error('Respuesta del servidor inesperada');

        return res;
      } catch (error: any) {
        console.error('Error al crear el banner:', error);
        return null;
      }
    },
    [callEndpoint]
  );

  return { createCreativityBanner };
};
